/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import { ActionMetadataList } from "./ActionMetadataList";
/**
 * <pre><code>This map represents the report workflow
 * Key - Represents the workflow state
 * value - Represents the allowed actions metadata for a given workflow state
 * Ex:
 * workflowConfig: {
 * START: [
 * {
 * actionType: DOWNLOAD,
 * flowType: INTERNAL
 * },
 * {
 * actionType: DOWNLOAD,
 * flowType: EXTERNAL
 * }
 * ],
 * INTERNAL_UPLOAD_SYSTEM: [
 * {
 * actionType: DOWNLOAD,
 * flowType: INTERNAL
 * },
 * {
 * actionType: DOWNLOAD,
 * flowType: EXTERNAL
 * }
 * ]
 * }
 * <\/code><\/pre>
 **/
export class ReportWorkflowConfig {
    constructor(options) {
        for (const key of Object.keys(options)) {
            this[key] = options[key];
        }
    }
    static fromJson(data) {
        const obj = {};
        for (const key of Object.keys(data)) {
            obj[key] = ActionMetadataList.fromJson(data[key]);
        }
        return new ReportWorkflowConfig(obj);
    }
    static toJson(map) {
        const data = {};
        for (const key of Object.keys(map)) {
            data[key] = ActionMetadataList.toJson(map[key]);
        }
        return data;
    }
}
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportWorkflowConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
export function validateReportworkflowconfig(data) {
    // TODO: Actually implement this!
    return data;
}
